'use client';
import {useAccount} from 'wagmi';
import {useDriveStore} from '../drive-store';
import { DocumentsTable } from '../files/table/table';

export function DocumentsLayout() {
  const {address} = useAccount();
  const documents = useDriveStore(s => s.documents);
  console.log('DocumentsLayout documents', documents);
  return (
    <>
      {documents && documents?.file_entries.length > 0 ? (
        <DocumentsTable fileEntries={documents?.file_entries} />
      ) : (
        <div className="bg-gray-100 flex h-screen items-center justify-center px-4">
          <div className="border-gray-300 w-full max-w-sm rounded-2xl border bg-white p-50 text-center shadow-xl">
            <p className="text-gray-700 text-xl font-semibold mb-2">
              No documents found
            </p>
            <p className="text-gray-500 text-sm">
              Upload documents to get started
            </p>
          </div>
        </div>
      )}
    </>
  );
}
